import React, { useState } from 'react';
import { Loader2, OctagonPause } from 'lucide-react';
import { useWorkflowStore } from '../../store/workflowStore';
import { stopExecution } from '../../services/stopExecution';

const hhmm = (iso) => {
  if (!iso) return '--:--';
  try {
    return new Date(iso).toLocaleTimeString('es-AR',
      { hour: '2-digit', minute: '2-digit' });
  } catch (_e) { return '--:--'; }
};

const LABEL = { queued: 'En cola', processing: 'Generando' };

/**
 * NodeBusyBadge — E6c.5
 *
 * Numerito con la cantidad de generaciones en curso de ESTE nodo. Al tocarlo,
 * lista chica con hora, estado y "Detener" por cada una. Se monta una sola vez
 * desde `withNodeTooltip`, así lo tienen los 25 nodos sin tocarlos.
 */
export const NodeBusyBadge = ({ nodeId }) => {
  const list = useWorkflowStore((s) => s.inFlight[nodeId]);
  const activeId = useWorkflowStore((s) => s.nodeActiveExecution[nodeId]);
  const removeInFlight = useWorkflowStore((s) => s.removeInFlight);
  const [open, setOpen] = useState(false);
  const [busyId, setBusyId] = useState(null);

  if (!list || list.length === 0) return null;

  const handleStop = async (event, execId) => {
    event.stopPropagation();
    setBusyId(execId);
    const ok = await stopExecution(execId);
    if (ok) {
      removeInFlight(nodeId, execId);
      window.dispatchEvent(new Event('executions:changed'));
    }
    setBusyId(null);
  };

  return (
    <div className="node-busy-badge-wrap nodrag">
      <button
        type="button"
        className="node-busy-badge"
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        title={`${list.length} generación(es) en curso de este nodo`}
        data-testid={`node-busy-badge-${nodeId}`}
      >
        <Loader2 size={9} className="spin" />
        {list.length}
      </button>

      {open && (
        <div
          className="node-busy-pop"
          onClick={(e) => e.stopPropagation()}
          data-testid={`node-busy-pop-${nodeId}`}
        >
          <div className="node-busy-pop-title">Generaciones de este nodo</div>
          {list.map((e) => (
            <div className="node-busy-pop-row" key={e.execution_id}>
              <span className="nbp-time">{hhmm(e.created_at || e.started_at)}</span>
              <span className={`nbp-state ${e.status}`}>
                {LABEL[e.status] || e.status}
              </span>
              {e.execution_id === activeId && (
                <span className="nbp-current" title="Es la que va a mostrar el nodo">
                  actual
                </span>
              )}
              <button
                type="button"
                className="nbp-stop"
                onClick={(ev) => handleStop(ev, e.execution_id)}
                disabled={busyId === e.execution_id}
                data-testid={`node-busy-stop-${e.execution_id}`}
              >
                {busyId === e.execution_id
                  ? <Loader2 size={10} className="spin" />
                  : <OctagonPause size={10} />}
                Detener
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NodeBusyBadge;
